import { useContext, useState } from 'react';
import { businessApiRoute, post } from './Api';
import * as Toast from './Toast.js';
import { ErrorContext } from './ErrorContext';

export default function (route, opts) {
    const [isSaving, setIsSaving] = useState(false);
    let res = null;
    const { errors, setErrors } = (res = useContext(ErrorContext));

    function save(data) {
        if (isSaving && !opts?.allowConcurrentSaves) {
            return {
                then: () => null,
                catch: () => null,
                finally: () => null,
            };
        }

        setIsSaving(true);
        if (setErrors) setErrors(null); // Reset if we're posting again
        return post(route, data)
            .catch(err => {
                const message = err.response?.data?.message;
                if (!opts?.noToast) {
                    if (message) {
                        Toast.error(message);
                    } else {
                        Toast.error('Failed to save, please try again');
                    }
                }

                if (typeof opts?.onError === 'function') {
                    opts.onError(message);
                }

                if (err.response?.data?.errors) {
                    if (setErrors) setErrors(err.response?.data?.errors);
                }

                throw err;
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    return {
        isSaving,
        save,
    };
}
